import use375Actions from '@/composables/actions/use375Actions'

export default function () {
  return {
    checkEligibility: (params) => {
      return use375Actions('checkEligibility', params)
    }
  }
}
